// client/src/api.js

import axios from "axios";

export const api = axios.create({
  baseURL: "https://orivon-academy-91tf.onrender.com",
});

// Attach token automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});








